module.exports = __webpack_public_path__ + "media/images/admin/favicons/favicon-32x32-3411e65e95bddcb32ec2f846642db34c.png";